export const isIE11 = () => window.navigator.userAgent.includes('Trident');
